import React, { forwardRef } from "react";
import styles from "./BurgerButton.module.scss";

const BurgerButton = forwardRef(function BurgerButton(
  { isOpen = false, onClick, className = "", ariaLabel = "Открыть меню" },
  ref
) {
  return (
    <button
      ref={ref}
      type="button"
      className={`${styles.burger} ${isOpen ? styles.open : ""} ${className}`}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-expanded={isOpen}
    >
      <span />
      <span />
      <span />
    </button>
  );
});

export default BurgerButton;
